import { AutogenModelDrsMan401k, AutogenRowDrsMan401k } from "./autogen/AutogenModelDrsMan401k";

export class ModelDrsMan401k extends AutogenModelDrsMan401k<RowDrsMan401k> {
	constructor() {
		super(RowDrsMan401k);
	}
}

export class RowDrsMan401k extends AutogenRowDrsMan401k {
}